import { create } from "zustand";
import MultiTenantClusterGetDto from "../dtos/multiTenantClusterDto";
import ClusterErrorType from "../models/clusterErrorType";
import { mountStoreDevtool } from "simple-zustand-devtools";

interface ClusterQuery {
  clusterItem?: string;
  organisations?: string[];
  changed?: boolean;
  originalCluster?: MultiTenantClusterGetDto;
  clearFilter?: boolean;
  clusters?: MultiTenantClusterGetDto[];
  newCluster?: boolean;
  disableSave?: boolean;
  revertChanges?: boolean;
  validationErrors?: ClusterErrorType[];
}

interface ClusterQueryStore {
  clusterQuery: ClusterQuery;
  setClusterItem: (clusterItem: string | undefined) => void;
  setOrganisations: (organisations: string[]) => void;
  setChanged: (changed: boolean) => void;
  setOriginalCluster: (originalCluster: MultiTenantClusterGetDto) => void;
  setClearFilter: (clearFilter: boolean) => void;
  setClusters: (clusters: MultiTenantClusterGetDto[]) => void;
  setNewCluster: (newCluster: boolean) => void;
  setDisableSave: (disableSave: boolean) => void;
  setRevertChanges: (revertChanges: boolean) => void;
  setValidationErrors: (validationErrors: ClusterErrorType[] | undefined) => void;
}

const useClusterQueryStore = create<ClusterQueryStore>((set) => ({
  clusterQuery: {},
  setClusterItem: (clusterItem: string | undefined) =>
    set((state) => ({ clusterQuery: { ...state.clusterQuery, clusterItem } })),
  setOrganisations: (organisations: string[]) =>
    set((state) => ({ clusterQuery: { ...state.clusterQuery, organisations } })),
  setChanged: (changed: boolean) => set((state) => ({ clusterQuery: { ...state.clusterQuery, changed } })),
  setOriginalCluster: (originalCluster: MultiTenantClusterGetDto) =>
    set((state) => ({ clusterQuery: { ...state.clusterQuery, originalCluster } })),
  setClearFilter: (clearFilter: boolean) => set((state) => ({ clusterQuery: { ...state.clusterQuery, clearFilter } })),
  setClusters: (clusters: MultiTenantClusterGetDto[]) =>
    set((state) => ({ clusterQuery: { ...state.clusterQuery, clusters } })),
  setNewCluster: (newCluster: boolean) => set((state) => ({ clusterQuery: { ...state.clusterQuery, newCluster } })),
  setDisableSave: (disableSave: boolean) => set((state) => ({ clusterQuery: { ...state.clusterQuery, disableSave } })),
  setRevertChanges: (revertChanges: boolean) =>
    set((state) => ({ clusterQuery: { ...state.clusterQuery, revertChanges } })),
  setValidationErrors: (validationErrors: ClusterErrorType[] | undefined) =>
    set((state) => ({ clusterQuery: { ...state.clusterQuery, validationErrors } })),
}));

if (process.env.NODE_ENV === "development") {
  mountStoreDevtool("Cluster Store", useClusterQueryStore);
}

export default useClusterQueryStore;
